import React, { Component } from 'react';
import { Text, Pressable, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';
import OPComponent from '../op_component';
import { PlusView } from './plus_view';

export default class HeaderButton extends OPComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { label, subLabel, onPress, disabled, containerStyle, labelStyle } = this.props;
    return (
      <Pressable
        style={[styles.headerButton, containerStyle]}
        onPress={onPress}
        disabled={!!disabled}
      >
        <Text style={[styles.headerLabel, labelStyle]}>{label}</Text>
        {!!subLabel && <Text style={styles.headerSubLabel}>{subLabel}</Text>}
        {!disabled && <PlusView />}
        {this.props.children}
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  headerButton: {
    height: 80,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLOR.altContrast,
    borderColor: '#e4e4e4',
    paddingHorizontal: 25,
    borderBottomWidth: 1,
  },
  headerLabel: {
    flex: 1,
    ...FONT.semibold,
    fontSize: FONT_SIZE.small,
    color: 'black',
  },
  headerSubLabel: {
    ...FONT.medium,
    fontSize: FONT_SIZE.small,
    color: COLOR.textLight,
    marginRight: 10,
  },
});
